// acc Reboot

export const EMAILJS_CONTACT_SERVICE_ID = process.env.VUE_APP_EMAILJS_CONTACT_SERVICE_ID
export const EMAILJS_CONTACT_TEMPLATE_ID = process.env.VUE_APP_EMAILJS_CONTACT_TEMPLATE_ID
export const EMAILJS_CONTACT_PUBLIC_KEY = process.env.VUE_APP_EMAILJS_CONTACT_PUBLIC_KEY

export const EMAILJS_CAREER_SERVICE_ID = process.env.VUE_APP_EMAILJS_CAREER_SERVICE_ID
export const EMAILJS_CAREER_TEMPLATE_ID = process.env.VUE_APP_EMAILJS_CAREER_TEMPLATE_ID
export const EMAILJS_CAREER_PUBLIC_KEY = process.env.VUE_APP_EMAILJS_CAREER_PUBLIC_KEY

export const isEmailjsConfigComplete = (...values) => values.every(Boolean)
